import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "..";
import { Header } from "..";
import { unsubscribe, upgrade, subscriptionList, checkSubcription, authorizationToken } from "../../wap/API/apiRequest";
import { getOperatorFromSubServiceId, normalizeOperator } from "../../wap/config/wapConfig";
import Loader from "../../wap/commonComponent/Loader";
import { Context } from "../../context/Context";
import moment from "moment";
import "moment/locale/ar";


function UpgradePlan() {
  const msisdn = localStorage.getItem("msisdn");
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const [status, setStatus] = useState('');
  const [showUnsub, setShowUnsub] = useState(true)
  const [isValidityExist, setIsValidityExists] = useState("")
  const { handleShowModal } = useContext(Context);

  moment.locale("ar");
  moment.updateLocale("ar", {
    preparse: function (string) {
      return string;
    },
    postformat: function (string) {
      return string.replace(/\d/g, (match) => "0123456789"[match]);
    }
  });

  useEffect(() => {
    getAuthorizationToken()
  }, [])

  const getAuthorizationToken = () => {
    setIsLoader(true);
    authorizationToken()
      .then((resp) => {
        console.log("auth token resp::", resp);
        if (resp?.data?.access_token) {
          const token = resp?.data?.token_type + " " + resp?.data?.access_token;
          if (token) sessionStorage.setItem("authToken", token);

          checkSubcription(msisdn)
            .then((resp) => {
              console.log("response in checksub::", resp);
              localStorage.setItem("userStatus", resp?.subscriptionResponse?.currentStatus?.toLowerCase())
              localStorage.setItem("userStatusExipry", resp?.subscriptionResponse?.cdrEndDate)
              setIsLoader(false)
              setStatus(resp)
              setIsValidityExists(resp.subscriptionResponse.reason)
              const currentStatus = resp.currentStatus;
              let subServiceId = resp?.subscriptionResponse?.subServiceId;
              const operator = getOperatorFromSubServiceId(subServiceId) || normalizeOperator(resp?.subscriptionResponse?.operator);
              if (operator) {
                localStorage.setItem("operator", operator)
              }
              console.log("::::::::subServiceId:::::::::::", subServiceId, "operator:", operator)
              if (operator === "madar") {
                if (subServiceId == "3 Day Madar") {
                  localStorage.setItem("uuid", "deb47400-0d85-11f1-a8ee-5d429e6c439d")
                }
                else if (subServiceId == "Monthly Madar") {
                  localStorage.setItem("uuid", "3e557bc0-0d86-11f1-aac1-6f6e63d4a3ef")
                }
                else if (subServiceId == "Weekly Madar") {
                  localStorage.setItem("uuid", "076f39e0-0d86-11f1-9bab-5170599866a9")
                }
              } else {
                if (subServiceId == "daily libyana") {
                  localStorage.setItem("uuid", "db2890c0-67ad-11f0-8756-85ba381b1758")
                }
                else if (subServiceId == "Monthly libyana") {
                  localStorage.setItem("uuid", "1c2d1180-67ae-11f0-8056-cd05cf2b50ec")
                }
                else if (subServiceId == "weekly libyana") {
                  localStorage.setItem("uuid", "e7ed7e20-67ad-11f0-a69c-2369a5da7f55")
                }
              }
              if (currentStatus === "unsub" || currentStatus === "unSubscribed" || currentStatus === "unsubscribed" || resp.subscriptionResponse.reason == "validity_exists") {
                setShowUnsub(false)
              }
            })
            .catch((err) => {
              console.log("Error in checksub::", err);
              setIsLoader(false)
            })
        } else if (resp?.errors) {
          const modalData = {
            title: "Error",
            body: 'البيانات المقدمة غير صحيحة.',
            messageCode: resp?.messageCode,
            buttons: [
              {
                label: "حسنًا",
                action: "close",
              },
            ],
            handleClick: function (value) {
              if (value === "close") {
                handleShowModal(false);
              }
              console.log("button clicked");
            },
          };
          handleShowModal(true, modalData);
        }
      })
      .catch((err) => {
        console.log("auth token err", err);
        setIsLoader(false);
        navigate("/sub-status?type=technical_error");
      });
  };

  const handleButton = (type) => {
    if (type === "upgradePlan") {
      navigate("/subscription?type=upgrade");
    }
    else if (type === "resubscribe") {
      navigate("/subscription?type=unsub");
    }
    else {
      setIsLoader(true)
      unsubscribe(msisdn)
        .then((resp) => {
          setIsLoader(false)
          console.log("unsub api resp::", resp);
          if (resp?.messageCode == "00") {
            navigate(`/otp?type=unsub`);
          } else if (resp?.messageCode == "12") {
            const modalData = {
              title: "Error",
              body: 'تم إلغاء الاشتراك بالفعل.',
              messageCode: resp?.messageCode,
              buttons: [
                {
                  label: "حسنًا",
                  action: "close",
                },
              ],
              handleClick: function (value) {
                if (value === "close") {
                  handleShowModal(false);
                }
                console.log("button clicked");
              },
            };
            handleShowModal(true, modalData);
          } else {
            navigate("/sub-status?type=technical_error");
          }
        })
        .catch((err) => {
          setIsLoader(false)
          navigate("/sub-status?type=technical_error");
          console.log("err in unsub api ::", err);
        });
    }
  };
  const rawUTC = status?.subscriptionResponse?.cdrEndDate;
  const givenDateUTC = new Date(rawUTC?.replace(" ", "T") + "Z");
  const nowUTC = new Date();

  return (
    <>
      {isLoader && <Loader />}
      <div className="bg-darkPurple flex flex-col h-screen main">
        <Header text={"backarrow"} />
        <div className="flex-grow mt-20">
          <div className="mt-2 bg-darkPurple flex text-center rounded-xl p-2 flex-col items-center text-white">
            <div className="w-full ">
              <div className="flex justify-between font-semibold w-full text-xl">
                <div dir="rtl" >حالة الاشتراك:</div>
                {status?.subscriptionResponse?.currentStatus && <div className="bg-lightGreen px-2 rounded-md">{status?.subscriptionResponse?.currentStatus === 'active' && givenDateUTC.getTime() < nowUTC.getTime() ? "مشترك" : status?.subscriptionResponse?.currentStatus === 'active' && isValidityExist !== "validity_exists" ? 'نشط' : status?.subscriptionResponse?.currentStatus === 'active' && isValidityExist === "validity_exists" ? "تم الإلغاء" : status?.subscriptionResponse?.currentStatus === 'unSubscribed' ? "غير مشترك" : 'غير نشط'}</div>}
              </div>
              {status?.subscriptionResponse?.subEndDate && <div dir="rtl" className="text-left mt-2 text-buttonYellow">
                {status?.subscriptionResponse?.subEndDate && (
                  <p>
                    تاريخ التجديد التالي الخاص بك هو - {status.subscriptionResponse.subEndDate.slice(0, 10)}
                  </p>
                )}
              </div>}
            </div>
            {showUnsub ? (<Button
              name="إلغاء الاشتراك الآن"
              handleClick={() => handleButton("unsubscribe")}
              className="h-12 bg-buttonYellow mt-8 rounded-full font-bold  text-darkPurple text-xl w-80"
            />) : (<Button
              name="تجديد الاشتراك"
              handleClick={() => handleButton("resubscribe")}
              className="h-12 bg-buttonYellow mt-8 rounded-full font-bold  text-darkPurple text-xl w-80"
            />)}
            {
              showUnsub ? <Button
                name="تحديث الباقة"
                handleClick={() => handleButton("upgradePlan")}
                className="h-12 bg-lightPurple mt-4 rounded-full font-bold  text-white text-xl w-80"
              /> : ""

            }

          </div>
        </div>
      </div>
    </>
  );
}

export default UpgradePlan;
